<template>
  <div>
    <!-- content -->
    <el-main class="content_size1 content_page_height" v-if="this.$objBaseInfo.channelId == 'WEB'">
      <el-row v-for="(item, idx) in this.hotelListFacility" :key="-idx" class="content_bg">
        <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="content_img" style="padding-left: 0">
          <div class="grid-content bg-purple list-img">
            <img alt="hotel_image" :src="item.hotelDescriptiveInfo.photos.length>0 ? (item.hotelDescriptiveInfo.photos[0].url?item.hotelDescriptiveInfo.photos[0].url:require('@/assets/img/hotel_img_error.png')) : require('@/assets/img/hotel_img_error.png')" @error="handleImgUrlError" style="cursor:pointer;width: 100%; height: 100%" />
          </div>
        </el-col>
        <el-col :xs="10" :sm="10" :md="10" :lg="10" :xl="10" class="list_hotel">
          <div id="line" class="grid-content bg-purple-light">
            <div class="list_hotel_content">
              <div id="sec_top">
                <div class="hotel_bigfont" :style="{pointerEvents:(item.unChoosen ?'none':'auto')}">
                  <el-col :xs="24" :sm="19" :md="19" :lg="19" :xl="19">
                    <el-row>
                      <!--CRM时显示资源方-->
                      <template v-if="pathSource == 'CRM' && item.hotelDescriptiveInfo.sources.length > 0">[{{ item.hotelDescriptiveInfo.sources.join(",") }}]</template>
                      <span style="color:#333f48;font-weight: 600;font-family:Sources Sans Pro;">{{ showHotelName(item.hotelDescriptiveInfo.name)}}</span>
                    </el-row>
                    <el-row class="hotel-rating-row">
                      <el-col class="hotel-rating-item" v-if="item.hotelDescriptiveInfo.standardStar > 0">
                        <el-rate v-model="item.hotelDescriptiveInfo.standardStar" disabled class="my-rate-reform" :colors="['#F2A900', '#F2A900', '#F2A900']"></el-rate>
                      </el-col>
                      <el-col class="hotel-rating-item" v-else>
                        <span v-for="n in item.hotelDescriptiveInfo.starRating" :key="n">
                          <svg-icon icon-class="hotel_icon_diamond" style="height: 13px;width:18px;"></svg-icon>
                        </span>
                      </el-col>
                      <el-col class="hotel-rating-emission hotel_midfont" v-if="item.emission && item.emission.score >= 45">
                        <div style="display: flex; align-items: center;">
                          <span class="rating-separator">{{ separator }}</span>
                          <svg-icon icon-class="emission" style="height: 17px;vertical-align: -0.4em;"></svg-icon>
                          <span style="color: #222A30; font-family: 'Source Sans Pro'; vertical-align: middle; display: inline-block;">{{ $t("RESULT.EMISSION")}}</span>
                        </div>
                      </el-col>
                    </el-row>
                  </el-col>
                  <el-col :xs="0" :sm="5" :md="5" :lg="5" :xl="5" v-if="getHotelMarking(item.hotelDescriptiveInfo)!=''
                    && ($objBaseInfo.channelId == 'WEB')">
                    <div class="contact_font hotel-marking">
                    {{getHotelMarking(item.hotelDescriptiveInfo)}}
                  </div>
                </el-col>
              </div>
            </div>
            <div id="sec_main">
              <div class="hotel_midfont" v-if="pathSource == 'CRM'">FXId:{{ item.hotelDescriptiveInfo.id}}</div>
              <div class="hotel_midfont list-content-tel">{{ $t("RESULT.TEL") }}{{ item.hotelDescriptiveInfo.contactNumber }}</div>
              <div class="hotel_midfont">{{ $t("RESULT.ADDRESS") }}{{ showHotelAddress(item.hotelDescriptiveInfo.address)}}</div>
            </div>
            <div id="sec_bottom">
              <template v-if="item && item.hotelDescriptiveInfo">
                <div>
                  <el-tooltip
                    v-for="(facility, index) in item.hotelDescriptiveInfo.facilities"
                    :key="index"
                    placement="top"
                    :disabled="!tooltipContent(facility)"
                    :content="tooltipContent(facility)"
                    effect="light"
                  >
                    <svg-icon 
                      :icon-class="objIcon[facility] || ''" 
                      style="width: 2.4rem; height: 2rem"
                    />
                  </el-tooltip>
                </div>
              </template> 
            </div>
          </div>
        </div>
        </el-col>
        <el-col :xs="4" :sm="4" :md="4" :lg="4" :xl="4" class="preferred-info-col">
          <div class="grid-content bg-purple list-content-preferred">
            <div 
              class="contact_font" 
              style="color:#FF694B;" 
              v-if="getHotelMarking(item.hotelDescriptiveInfo)!='' && (objBaseInfo.channelId == 'MOBILE')"
            >
              {{getHotelMarking(item.hotelDescriptiveInfo)}}
            </div>
            <div class="contact_font" style="margin-top: 1rem" v-show="item.isAgencyPreferredHotel && !item.isClientPreferredHotel">
              {{$t("RESULT.CWTHOTEL")}}
            </div>
            <div 
              class="contact_font" 
              v-show="item.isClientPreferredHotel && getCpHotelMark(item)!=''" 
              style="margin-top: 1rem;display: flex;align-items: center;"
            >
              <!--CRM时显示CONTRACTEDHOTELCRM和图标-->
              <span> {{ getCpHotelMark(item) }}</span>
              <template v-if="pathSource == 'CRM'">
                <img alt="source" src="@/assets/img/protocolPic.png" />
              </template>
            </div>
            <div class="contact_font" v-show="item.isCorpPayHotel" style="margin-top: 1rem">
              {{ item.corpPayHotelName }}
            </div>
            <div class="contact_font" v-if="getNotRecommendedShow(item.hotelDescriptiveInfo.group)" style="margin-top: 1rem">
              {{getNotRecommendedText}}
            </div>
          </div>
        </el-col>
        <el-col :xs="5" :sm="5" :md="5" :lg="5" :xl="5" class="list_price">
          <div id="search_area">
            <template v-if="objBaseInfo.showTravelTitle && objBaseInfo.displayTravelRules">
              <div id="top" class="list_policy" v-if="item.isOutOfPolicy===false">
                <div class="policy_outof_in policy_in_color policy_svg" v-show="objBaseInfo.hotelBookingRole ==1 ">
                  {{ $t("MESSAGE.INPOLICY") }}
                </div>
              </div>
              <div class="list_policy" v-else-if="item.isOutOfPolicy && objBaseInfo.hotelBookingRole == 1">
                <el-tooltip
                  :disabled="!objBaseInfo.policySwitch"
                  placement="top"
                  effect="light"
                  :visible="ResultData.isToolTip['toolTip' + item.hotelDescriptiveInfo.id]"
                >
                  <template #content>
                    <div v-for="(d, i) in policyDescriptions(item)" :key="i" v-text="d" style="white-space: pre-line;"></div>
                  </template>
                  <div 
                    class="policy_outof_in policy_outof_color policy_svg"
                    @click="ResultData.toMobileDetail('toolTip' + item.hotelDescriptiveInfo.id)"
                  >
                    {{ $t("MESSAGE.OUTOFPOLICY") }}
                  </div>
                </el-tooltip>
              </div>
              <div class="list_policy" v-else></div>
            </template>
            <div id="main">
              <span class="hotel_list_price">
                {{(item.currencyCode? $currencySign[item.currencyCode]: objBaseInfo.defaultCurrencySign) + item.averagePrice}}
              </span>
              <span style="font-size: 1.5rem;margin-right: .5rem;font-weight: 600;">{{$t("RESULT.ABOVE")}}</span>
            </div>
            <div class="hotel_price">
              <div v-if="ResultData.currencyCode ==='0'&& item.usDollar" class="hotel_list_price2">
                {{ $t("RESULT.ESTIMATEDPRICE") }}${{ item.usDollar }}
              </div>
              <div v-if="ResultData.currencyCode ==='1'&& item.european" class="hotel_list_price2">
                {{ $t("RESULT.ESTIMATEDPRICE") }}€{{ item.european }}
              </div>
              <div v-if="ResultData.currencyCode ==='2' && item.ChineseCNY" class="hotel_list_price2">
                {{ $t("RESULT.ESTIMATEDPRICE") }}¥{{ item.ChineseCNY }}
              </div>
            </div>
            <div id="bottom">
              <button 
                class="s_btn s_btn_small btn_book" 
                @click="ResultData.toDetail(item)" 
                :disabled="item.unChoosen" 
                :style="{backgroundColor:(item.unChoosen ?'#C0C0C0':'#fc6640')}"
              >
                {{ $t("RESULT.CHECKAVAILABILITY") }}
              </button>
            </div>
          </div>
        </el-col>
      </el-row>
      <loading :loading="ResultData.hotelloading" :isFloatingLayer="ResultData.loadingIsFloatingLayer" />
      <el-row v-if="ResultData.noMoreData" class="showmore_content">
        <el-col :span="24" class="center_style">
          <div class="grid-content nomore_font">{{ $t("RESULT.NOMORE") }}</div>
        </el-col>
      </el-row>
    </el-main>
    <el-main class="content_size1 content_page_height" v-if="objBaseInfo.channelId == 'MOBILE'">
      <el-row>
        <van-tag type="primary" size="large" plain v-if="ResultData.showHotelListNotice" @click="hotelListNoticeDialogVisible = true" class="vant-announcement">
          <div class="travelRule" v-if="ResultData.showHotelListNotice">
            <div class='butt'><i class="el-icon-document" style="margin-right:2px;"></i>{{ ResultData.noticeTitle }}</div>
          </div>
        </van-tag>
      </el-row>
      <el-row v-for="(item, idx) in this.hotelListFacility" :key="idx" class="content_bg">
        <div @click="ResultData.toMobileDetail(item)" style="display: grid;grid-template-columns: 1fr 1.5fr;">
          <el-col>
            <img alt="hotel_image" @click="ResultData.toDetail(item)" :src="item.hotelDescriptiveInfo.photos.length>0 ? (item.hotelDescriptiveInfo.photos[0].url?item.hotelDescriptiveInfo.photos[0].url:require('@/assets/img/hotel_img_error.png')) : require('@/assets/img/hotel_img_error.png')" @error="handleImgUrlError" style="object-fit: cover;width: 100%; height: 100%;height: 26rem;" />
          </el-col>
          <el-col style="padding-left: 1rem;position: relative;">
            <el-row>
              <span style="color: #222A30;font-size: 1.8rem;font-family: 'Source Sans Pro';font-weight: bold;">{{ item.hotelDescriptiveInfo.name[$t('RESULT.RESPONSEDATA.name')] }}</span>
            </el-row>
            <el-row style="display: flex; align-items: flex-end;">
              <el-col :span="0.1" v-if="item.hotelDescriptiveInfo.standardStar > 0">
                <el-rate v-model="item.hotelDescriptiveInfo.standardStar" disabled class="my-rate-reform" :colors="['#F2A900', '#F2A900', '#F2A900']"></el-rate>
              </el-col>
              <el-col :span="0.1" v-else>
                <span v-for="n in item.hotelDescriptiveInfo.starRating" :key="n">
                  <svg-icon icon-class="hotel_icon_diamond" style="height: 13px;width:18px;"></svg-icon>
                </span>
              </el-col>
              <el-col :span="0.9" class="hotel_midfont" v-if="item.emission && item.emission.score >= 45">
                <div style="display: flex; align-items: end;">
                  <span class="rating-separator">{{ separator }}</span>
                  <svg-icon icon-class="emission" style="height: 14px;vertical-align: -0.4em;"></svg-icon>
                  <span style="color: #222A30; font-family: 'Source Sans Pro'; vertical-align: middle; display: inline-block;">{{ $t("RESULT.EMISSION")}}</span>
                </div>
              </el-col>
            </el-row>
            <el-row>
              <div class="grid-content bg-purple list-content-preferred">
                <div class="div_grid" v-show="item.isAgencyPreferredHotel && !item.isClientPreferredHotel">
                  <svg-icon icon-class="ic_result_notRecommended" style="width: 1.4rem; height: 1.4rem"></svg-icon>
                  <div style="line-height: 1.5rem;color: #808080;">
                    <span>{{ $t("RESULT.CWTHOTEL") }}</span>
                  </div>
                </div>
                <div class="div_grid" v-show="item.isClientPreferredHotel && getCpHotelMark(item)!=''">
                  <svg-icon icon-class="ic_result_notRecommended" style="width: 1.4rem; height: 1.4rem"></svg-icon>
                  <div style="line-height: 1.5rem;color: #808080;">
                    <span>{{ getCpHotelMark(item) }}</span>
                  </div>
                </div>
                <div class="div_grid" v-show="item.isCorpPayHotel">
                  <svg-icon icon-class="ic_result_notRecommended" style="width: 1.4rem; height: 1.4rem"></svg-icon>
                  <div style="line-height: 1.5rem;color: #808080;">
                    <span>{{ item.corpPayHotelName  }}</span>
                  </div>
                </div>
                <div class="div_grid" v-if="getHotelMarking(item.hotelDescriptiveInfo)!= undefined && getHotelMarking(item.hotelDescriptiveInfo)!= ''">
                  <svg-icon icon-class="ic_result_notRecommended" style="width: 1.4rem; height: 1.4rem"></svg-icon>
                  <div style="line-height: 1.5rem;color: #808080;">
                    <span>{{ getHotelMarking(item.hotelDescriptiveInfo) }}</span>
                  </div>
                </div>
                <div class="div_grid" v-if="getNotRecommendedShow(item.hotelDescriptiveInfo.group)">
                  <svg-icon icon-class="ic_result_notRecommended" style="width: 1.4rem; height: 1.4rem"></svg-icon>
                  <div style="line-height: 1.5rem;color: #808080;">
                    <span>{{ getNotRecommendedText }}</span>
                  </div>
                </div>
              </div>
            </el-row>
            <div style="position: absolute;bottom: 0.8rem;right: 0;padding-right: 1rem;">
              <el-row>
                <template v-if="objBaseInfo.showTravelTitle && objBaseInfo.displayTravelRules">
                  <div id="top" style="text-align: end;" v-if="item.isOutOfPolicy===false">
                    <div style="padding: 0.2rem 0.5rem;" v-show="objBaseInfo.hotelBookingRole ==1 ">{{ $t("MESSAGE.INPOLICY") }}</div>
                  </div>
                  <div class="list_policy" v-else-if="item.isOutOfPolicy && objBaseInfo.hotelBookingRole == 1" @click="ResultData.toMobileDetail('toolTip' + item.hotelDescriptiveInfo.id)">
                    <el-tooltip
                      :disabled="!objBaseInfo.policySwitch"
                      placement="top"
                      effect="light"
                      v-model="ResultData.isToolTip['toolTip' + item.hotelDescriptiveInfo.id]">
                      <template #content>
                        <div v-for="(d, i) in policyDescriptions(item)" :key="i" v-text="d" style="white-space: pre-line;"></div>
                      </template>
                      <div style="padding: 0.2rem 0.5rem; color: rgb(255, 105, 75);">
                        {{ $t("MESSAGE.OUTOFPOLICY") }}
                      </div>
                    </el-tooltip>
                  </div>
                  <div class="list_policy" v-else></div>
                </template>
              </el-row>
              <el-row>
                <div id="search_area">
                  <div id="main">
                    <span style="color: #FF694B;" class="hotel_list_price" >
                      <span style="font-size: 1rem;">{{ item.currencyCode? $currencySign[item.currencyCode]: objBaseInfo.defaultCurrencySign }}</span>
                      <span style="font-size: 2.5rem;font-family: Arial, sans-serif;font-weight: bold;">{{ item.averagePrice }}</span>
                      <span style="font-size: 1.5rem;margin-right: .5rem;font-weight: 600;">{{$t("RESULT.ABOVE")}}</span>
                    </span>
                  </div>
                  <div class="hotel_price">
                    <div v-if="ResultData.currencyCode ==='0'&& item.usDollar" class="hotel_list_price2">{{ $t("RESULT.ESTIMATEDPRICE") }}${{ item.usDollar }}</div>
                    <div v-if="ResultData.currencyCode ==='1'&& item.european" class="hotel_list_price2">{{ $t("RESULT.ESTIMATEDPRICE") }}€{{ item.european }}</div>
                    <div v-if="ResultData.currencyCode ==='2' && item.ChineseCNY" class="hotel_list_price2">{{ $t("RESULT.ESTIMATEDPRICE") }}¥{{ item.ChineseCNY }}</div>
                  </div>
                </div>
              </el-row>
            </div>
          </el-col>
        </div>
      </el-row>
      <loading :loading="ResultData.hotelloading" :isFloatingLayer="ResultData.loadingIsFloatingLayer" />
      <el-row v-if="ResultData.noMoreData" class=" showmore_content">
        <el-col :span="24" class="center_style">
          <div class="grid-content nomore_font">{{ $t("RESULT.NOMORE") }}</div>
        </el-col>
      </el-row>
    </el-main>
  </div>
</template>
<script>
import { getCurrentInstance } from 'vue';
import Loading from "@/components/Loading.vue";
import { iconSvg,commonIcon } from "@/config/icon";
import { getDictionaryItem } from "@/utils/getDictionaryData.js";
import { showToast } from "vant";
export default {
  name: "ResultContent",
  components: {
    Loading,
  },
  inject: ['ResultData'],
  data() {
    return {
      pathSource: "",
      objIcon: iconSvg,
      arrCommonIcon: commonIcon,
      objBaseInfo: {}, // 存储全局属性
    }
  },
  created() {
    const instance = getCurrentInstance();
    if (instance) {
      this.objBaseInfo = instance.appContext.config.globalProperties.$objBaseInfo || {};
      this.pathSource = this.objBaseInfo.sourceType ? this.objBaseInfo.sourceType : "";
    }
  },
  computed: {
    //是否隐藏不推荐
    getNotRecommendedShow(){
      return function(groupid) {
        let flag=false;
        if(this.objBaseInfo && Object.prototype.hasOwnProperty.call(this.objBaseInfo, "notRecommendedModel")){
          let notRecommendedModel=this.objBaseInfo.notRecommendedModel;
          if(notRecommendedModel != undefined && notRecommendedModel != null){
            let arrGroupid=notRecommendedModel.notRecommendedGorupid.split(',');
            if (arrGroupid.indexOf(groupid.toString()) >= 0){
              flag=true;
            }
          }
        }
        return flag;
      };
    },
    getNotRecommendedText(){
      let text="";
      if(this.objBaseInfo && Object.prototype.hasOwnProperty.call(this.objBaseInfo, "notRecommendedModel")){
        let notRecommendedModel=this.objBaseInfo.notRecommendedModel;
        if(notRecommendedModel!=undefined && notRecommendedModel!=null){
          if (this.$i18n.locale == "en"){
            text=notRecommendedModel.notRecommendedEN;
          }else{
            text=notRecommendedModel.notRecommendedCN;
          }
        }
      }
      return text;
    },
    hotelListFacility: function () {
      let $this = this;
      return this.ResultData.hotelList.filter(function (hotel) {
        hotel.hotelDescriptiveInfo.facilities = Array.from(
          new Set(
            hotel.hotelDescriptiveInfo.facilities.filter(function (f) {
              
              if($this.objBaseInfo.destinationType == "I"||($this.objBaseInfo.destinationType == "D"&& $this.objBaseInfo.isGATCity)){
                if($this.ResultData.wifiList.indexOf(f) > -1){
                  return;
                }
              }
              return $this.arrCommonIcon.indexOf(f) > -1;
            })
          )
        );
        if(hotel.isCorpPayHotel){
          if($this.ResultData.isCorpPay && $this.ResultData.isPrepay){
            hotel.corpPayHotelName = $this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE3") + "|" + $this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE2");
          }else if($this.ResultData.isCorpPay){
            hotel.corpPayHotelName = $this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE3");
          }else if($this.ResultData.isPrepay){
            hotel.corpPayHotelName = $this.$t("COMMONPARAM.PAYMENTTYPE.PAYMENTTYPE2");
          }
        }
        return hotel;
      });
    },
    separator() {
      return "| ";
    }
  },
  methods: {
    handleImgUrlError(e) {
      e.target.src = require('@/assets/img/hotel_img_error.png')
    },
    tooltipContent(facility) {
      const facilityData = getDictionaryItem(facility,"facility");
      if (!facilityData) return '';
      const translatedKey = this.$t("DETAIL.RESPONSEDATA.facility");
      return facilityData[translatedKey] || '';
    },
    showEmission() {
      showToast(this.$t('RESULT.EMISSIONTIP'));
    },
    showHotelAddress(hotelAddress){
      if(this.pathSource == "CRM") {
        if(this.objBaseInfo.isGATCity || this.objBaseInfo.destinationType == "I") {
          return hotelAddress["zh-CN"] + '(' + hotelAddress["en"] + ')';
        }
      }
      return hotelAddress[this.$t("RESULT.RESPONSEDATA.address")];
    },
    showHotelName(hotelName){
      if(this.pathSource == "CRM")
      {
        if(this.objBaseInfo.isGATCity || this.objBaseInfo.destinationType == "I"){
          return hotelName["zh-CN"]+'(' + hotelName["en"] +')' ;
        }
      }
      return hotelName[this.$t('RESULT.RESPONSEDATA.name')];
    },
    //获取酒店打标
    getHotelMarking(hotelDescriptiveInfo){
      let value = "";
      if(hotelDescriptiveInfo && Object.prototype.hasOwnProperty.call(hotelDescriptiveInfo, "cwtMark")){
        if(hotelDescriptiveInfo.cwtMark != undefined && hotelDescriptiveInfo.cwtMark != null){
          let mark=hotelDescriptiveInfo.cwtMark;
          if(this.$i18n.locale == "en"){
            value = mark["en"] || "";
          }
          else{
            value = mark["zh-CN"] || "";
          }
        }
      }
      return typeof value === "string" ? value.trim() : "";
    },
    getCpHotelMark(item){
      if(!item.isFixedCPHotel)
      {
        if(this.objBaseInfo.isShowChainWide){
          return this.$t("RESULT.CHAIMWIDE");
          }
          return "";
      }
      return this.$t("RESULT.CONTRACTEDHOTEL");
    },
    getNotRecommendedText1(){
      let text="";
      if(this.objBaseInfo && Object.prototype.hasOwnProperty.call(this.objBaseInfo, "notRecommendedModel")){
        let notRecommendedModel=this.objBaseInfo.notRecommendedModel;
        if(notRecommendedModel!=undefined && notRecommendedModel!=null){
          if (this.$i18n.locale == "en"){
            text=notRecommendedModel.notRecommendedEN;
          }else{
            text=notRecommendedModel.notRecommendedCN;
          }
        }
      }
      return text;
    },
    policyDescriptions(item) {
      const currencySign = item.currencyCode
        ? this.$currencySign[item.currencyCode]
        : this.objBaseInfo.defaultCurrencySign;
      let arrResult = [],
        strResult1 = "",
        strResult2 = "",
        strResult = "";
        var arr = item.outOfPoliyDescriptions;
        if(this.$objBaseInfo.policySwitch && this.$objBaseInfo.personalizationPolicySwitch && this.$objBaseInfo.personalizationPolicyInfo && this.$objBaseInfo.personalizationPolicyInfo.descCn){
          strResult = this.$i18n.locale == "en"?this.$objBaseInfo.personalizationPolicyInfo.descEn : this.$objBaseInfo.personalizationPolicyInfo.descCn;
          if(item.posHotelTravelRuleDescFlag)
          {
             strResult = this.$i18n.locale == "en"?item.posHotelTravelRuleDescEn : item.posHotelTravelRuleDescCn;
          }
        }else{
          if (arr.length == 0) {
            strResult = this.$t("RESULT.OUTOFPOLICYTIPEMPTY");
          } else {
            for (let obj in arr) {
              let objOutofPolicy = {};
              if (arr[obj]["key"] === "amountTopLimit") {
                objOutofPolicy.price = arr[obj]["value"];
                strResult1 = this.$t("RESULT.OUTOFPOLICYTIP1", {
                  price: currencySign + objOutofPolicy.price,
                });
              } 
              if (arr[obj]["key"] === "NegotiationPrice") {
                strResult2 =  this.$t("RESULT.OUTOFPOLICYTIP3");
              }
            }
            strResult = strResult1 + (strResult1 === "" ? "" : "\n") + strResult2;
          }
        }
        arrResult.push(strResult);
        return arrResult;
    },
  }
}
</script>

<style scoped>
@media screen and (max-width: 960px) {
  .rating-separator {
    display: inline-flex;
    align-items: center;
    margin: 0 0.2rem;
    color: #E7E9EA;
    font-size: 1.6rem;
    font-weight: 600;
    line-height: 1;
  }
}

@media screen and (min-width: 961px) {
  .rating-separator {
    display: inline-flex;
    align-items: center;
    margin: 0 0.4rem;
    color: #E7E9EA;
    font-size: 1.8rem;
    font-weight: 600;
    line-height: 1;
  }

  .hotel-rating-row {
    display: flex;
    align-items: center;
    flex-wrap: nowrap;
    min-height: 2rem;
  }

  .hotel-rating-row > .hotel-rating-item,
  .hotel-rating-row > .hotel-rating-emission {
    width: auto;
    flex: 0 0 auto;
  }

  .hotel-rating-item {
    display: inline-flex;
    align-items: center;
    min-height: 2rem;
  }

  .hotel-rating-item .my-rate-reform {
    display: flex;
    align-items: center;
    height: 2rem;
    line-height: 1;
    transform: translateY(0.35rem);
  }

  .content_bg .hotel-marking {
    width: 100%;
    height: auto !important;
    min-height: 2rem;
    padding-top: 1rem;
    color: #FF694B;
    line-height: 1.8rem;
    text-align: right;
    overflow-wrap: anywhere;
    white-space: normal;
  }

  .content_bg .preferred-info-col {
    margin-top: 2.5rem;
  }

  .content_bg {
    height: auto !important;
    align-items: stretch;
    overflow: visible;
  }

  .content_bg .content_img,
  .content_bg .list-img {
    height: clamp(16rem, 20vw, 22.7rem) !important;
    min-height: 16rem;
    max-height: 22.7rem;
    align-self: flex-start;
  }

  .content_bg .list_hotel_content,
  .content_bg #sec_top,
  .content_bg #sec_main,
  .content_bg #sec_bottom {
    height: auto !important;
    min-height: 0;
  }

  .content_bg > .list_hotel {
    align-self: stretch;
    display: flex;
    flex-direction: column;
  }

  .content_bg .list_hotel_content {
    display: flex;
    flex-direction: column;
    height: auto !important;
    min-height: clamp(16rem, 20vw, 22.7rem);
    box-sizing: border-box;
  }

  .content_bg #sec_main {
    margin-top: 1rem;
  }

  .content_bg #sec_bottom {
    margin-top: auto;
    padding-bottom: 0.5rem;
  }
}
</style>
